module.exports = __webpack_public_path__ + "img/service1-06.420ce78c.png";